@if (NavigateTitle == "Explore") {
  @if (isShareAndSave) {
    <div class="row justify-content-center">
      <div class="col">
        <div class="d-flex dashboard-box success">
          <div
            class="circle d-flex flex-column align-items-center justify-content-center"
            (click)="NavigateTo()"
            [ngStyle]="
              getGlassButtonStyle(Merchant$ | async, {
                position: 'relative',
                overflow: 'hidden',
              })
            "
          >
            @if ((Merchant$ | async)?.webapp_settings?.show_shadow_effect) {
              <div
                [ngStyle]="{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '45%',
                  background:
                    'linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0))',
                  'border-top-left-radius': '999px',
                  'border-top-right-radius': '999px',
                  'pointer-events': 'none',
                  'z-index': '1',
                }"
              ></div>
            }

            <div
              class="about-icon"
              [ngStyle]="{
                'background-color': (Merchant$ | async)?.webapp_settings
                  ?.menu_font_color_homepgae,
                mask: 'url(assets/img/explore.png) no-repeat center / contain',
                '-webkit-mask':
                  'url(assets/img/explore.png) no-repeat center / contain',
                width: '40px',
                height: '40px',
                display: 'block',
                'margin-bottom': '6px',
                position: 'relative',
                'z-index': '2',
                filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.35))',
              }"
            ></div>

            <h6
              class="heading mb-0 button text-center notranslate"
              [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings
                  ?.menu_font_color_homepgae,
                'font-size': '18px',
                position: 'relative',
                'z-index': '2',
                'text-shadow': '0 1px 3px rgba(0,0,0,0.35)',
              }"
              translate="no"
            >
              {{ NavigateTitle }}
            </h6>
          </div>

          <div
            class="circle d-flex align-items-center justify-content-center"
            (click)="OpenPopup()"
            [ngStyle]="
              getGlassButtonStyle(Merchant$ | async, {
                'padding-left': '10px',
                'padding-right': '35px',
              })
            "
          >
            @if ((Merchant$ | async)?.webapp_settings?.show_shadow_effect) {
              <div
                [ngStyle]="{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '45%',
                  background:
                    'linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0))',
                  'border-top-left-radius': '999px',
                  'border-top-right-radius': '999px',
                  'pointer-events': 'none',
                  'z-index': '1',
                }"
              ></div>
            }

            <div
              class="d-flex align-items-center gap-2"
              style="position: relative; z-index: 2"
            >
              <div
                class="whatson-icon"
                [ngStyle]="{
                  'background-color': (Merchant$ | async)?.webapp_settings
                    ?.menu_font_color_homepgae,
                  mask: 'url(assets/img/showsave.png) no-repeat center / contain',
                  '-webkit-mask':
                    'url(assets/img/showsave.png) no-repeat center / contain',
                  width: '30px',
                  height: '30px',
                  display: 'block',
                  filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.35))',
                }"
              ></div>

              <h6
                class="heading mb-0 button text-center"
                translate="no"
                [ngStyle]="{
                  color: (Merchant$ | async)?.webapp_settings
                    ?.menu_font_color_homepgae,
                  'margin-left': '-10px',
                  'font-size': '18px',
                  'text-shadow': '0 1px 3px rgba(0,0,0,0.35)',
                }"
              >
                Show <br />
                & <br />
                Save
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="row justify-content-center">
      <div class="col">
        <div class="dashboard-box success notranslate">
          <div
            class="circle d-flex flex-column align-items-center justify-content-center"
            (click)="NavigateTo()"
            [ngStyle]="
              getGlassButtonStyle(Merchant$ | async, { padding: '6px' })
            "
          >
            @if ((Merchant$ | async)?.webapp_settings?.show_shadow_effect) {
              <div
                [ngStyle]="{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '45%',
                  background:
                    'linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0))',
                  'border-top-left-radius': '999px',
                  'border-top-right-radius': '999px',
                  'pointer-events': 'none',
                  'z-index': '1',
                }"
              ></div>
            }
            <div
              class="about-icon"
              [ngStyle]="{
                'background-color': (Merchant$ | async)?.webapp_settings
                  ?.menu_font_color_homepgae,
                mask: 'url(assets/img/explore.png) no-repeat center / contain',
                '-webkit-mask':
                  'url(assets/img/explore.png) no-repeat center / contain',
                width: '40px',
                height: '40px',
                display: 'block',
                'margin-bottom': '6px',
              }"
            ></div>

            <!-- Bottom: Title -->
            <h6
              class="heading mb-0 button text-center notranslate"
              [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings
                  ?.menu_font_color_homepgae,
                'font-size': '18px',
              }"
              translate="no"
            >
              {{ NavigateTitle }}
            </h6>
          </div>
        </div>
      </div>
    </div>
  }
}
@if (NavigateTitle == "Menu") {
  <div class="col">
    <div class="dashboard-box-menu about-box success position-relative mt-0">
      <div
        class="d-flex align-items-center justify-content-center self-checkout"
        (click)="OpenSmartSearch()"
        style="display: none !important"
        [ngStyle]="{
          backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border:
            (Merchant$ | async)?.webapp_settings?.menu_border_width +
            'px solid ' +
            (Merchant$ | async)?.webapp_settings?.menu_border_color,
        }"
      >
        <i
          [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings
              ?.menu_font_color_homepgae,
          }"
          class="zmdi zmdi-money zmdi-hc-fw"
        ></i>
      </div>

      <div
        class="circle d-flex align-items-center justify-content-center"
        (click)="NavigateTo()"
        [ngStyle]="{
          backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border:
            (Merchant$ | async)?.webapp_settings?.menu_border_width +
            'px solid ' +
            (Merchant$ | async)?.webapp_settings?.menu_border_color,
        }"
      >
        <h5
          class="heading-menu mb-0 button"
          [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings
              ?.menu_font_color_homepgae,
          }"
          translate="no"
          [innerHTML]="NavigateTitle"
        ></h5>
      </div>

      <div
        class="d-flex align-items-center justify-content-center smart-search"
        (click)="OpenSmartSearch()"
        [ngStyle]="{
          backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border:
            (Merchant$ | async)?.webapp_settings?.menu_border_width +
            'px solid ' +
            (Merchant$ | async)?.webapp_settings?.menu_border_color,
        }"
      >
        <img
          src="assets/img/magnifier-glass.svg"
          style="width: 35px"
          [style]="ButtonColor | async"
        />
      </div>
    </div>
  </div>
}

<app-messagepopup></app-messagepopup>

@if (ProductSearch) {
  <!-- Modal content -->
  <div class="modal" style="display: block !important">
    <div class="modal-content">
      <div
        class="modal-header"
        [ngStyle]="{
          'justify-content': 'right',
          height: '40px',
          backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          'border-bottom':
            (Merchant$ | async)?.webapp_settings?.menu_border_width +
            'px solid ' +
            (Merchant$ | async)?.webapp_settings?.menu_border_color,
        }"
      >
        <a (click)="CloseSmartSearch()" id="btnnotification" class="close-icon">
          <i
            [ngStyle]="{
              color: (Merchant$ | async)?.webapp_settings
                ?.menu_font_color_homepgae,
            }"
            class="zmdi zmdi-close zmdi-hc-fw"
          ></i>
        </a>
      </div>
      <!-- istoodle flag used for hide table selection when user select pay with toodle option (Deeplink check ) -->
      <div class="modal-body">
        <div class="col">
          <div class="form-group" style="width: 100%">
            <ng-select
              [items]="movies$ | async"
              bindLabel="name"
              [trackByFn]="trackByFn"
              [minTermLength]="minLengthTerm"
              [loading]="moviesLoading"
              placeholder="Start typing to search"
              (scrollToEnd)="FetchMore()"
              [typeahead]="moviesInput$"
              [(ngModel)]="selectedMovie"
              #select
            >
            </ng-select>
          </div>
        </div>

        <div class="modal-footer" [ngStyle]="{ display: 'block' }">
          <div class="d-grid">
            <button
              class="btn btn-accent-theme btn-lg mt-2"
              [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings
                  ?.menu_font_color_homepgae,
                backgroundColor: (Merchant$ | async)?.webapp_settings
                  ?.menu_color,
                border:
                  (Merchant$ | async)?.webapp_settings?.menu_border_width +
                  'px solid ' +
                  (Merchant$ | async)?.webapp_settings?.menu_border_color,
              }"
              (click)="
                OpenProduct(
                  select.selectedValues[0],
                  select.selectedValues[0].id
                )
              "
            >
              OK
            </button>
          </div>
        </div>
      </div>
      <!-- without inputbox -->
    </div>
  </div>
}

@if (AddProductVisible) {
  <app-add-product
    [isProductVisible]="ProductVisible"
    [selectedProductId]="product?.id"
    [tempBool]="tempBool"
    [isInfoPopup]="viewOnly"
  ></app-add-product>
}
